import { render, staticRenderFns } from "./SortableListThumb.vue?vue&type=template&id=e0ca8994&scoped=true"
import script from "./SortableListThumb.vue?vue&type=script&lang=js"
export * from "./SortableListThumb.vue?vue&type=script&lang=js"
import style0 from "./SortableListThumb.vue?vue&type=style&index=0&id=e0ca8994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ca8994",
  null
  
)

export default component.exports